export default "__VITE_ASSET__BRn7By26__"